export default __webpack_public_path__ + "static/media/tpc_billable.48885b72.svg";